/*! dependencies: toggle-height */

cash('.ribbonAccordion .js-headline-wrapper').on('click', function () {
  var currentWrapper = cash(this),
    iconSVG = currentWrapper.find('svg'),
    closestSection = currentWrapper.closest('.js-section'),
    textWrapper = closestSection.find('.js-text-wrapper'),
    accordionSections = closestSection.closest('.js-accordion-sections'),
    autoClose = accordionSections.data('auto-close');

  if (autoClose === 'True') {
    var textWrappers = accordionSections.find('.js-section .js-text-wrapper');

    cash.each(textWrappers, function () {
      if (this != textWrapper[0]) {
        cash(this).closest('.js-section').removeClass('on');
        instant.toggleHeight.close(cash(this));
      }
    });
  }

  iconSVG.toggleClass('rotate-180');

  closestSection.toggleClass('on');

  instant.toggleHeight.toggle(textWrapper);
});